import React from 'react';

import {ENGAGEMENTS} from '../utils/constants';

import EngagementsTable from '../../../Common/EngagementsTable';
import StyledInputWithHeader from '../StyledInputWithHeader';

const Engagements = ({
	values,
	errors,
	handleChange,
	handleSubmit,
	handleReset,
	isFormValid,
	labels,
	engagements,
	renderHeader
}) => {
	const id = ENGAGEMENTS;

	const props = {
		items: engagements,
		selected: [...values[id]],
		onSelect: (newValue) => handleChange(id, newValue),
		maxSelect: 1,
		labels
	};

	if (errors[id]) props.errorMessage = errors[id]?.message;

	return (
		<StyledInputWithHeader className="engagements">
			{renderHeader(labels[id])}
			<EngagementsTable {...props} />
		</StyledInputWithHeader>
	);
};

export default Engagements;
